<template>
  <div class="Square">
    <div
      class="Square__Pic cursor-pointer bg-white rounded-md z-1"
      @click.stop="open"
    >
      <div 
        v-if="antivirusState === 'hasVirus'"
        class="absolute inset-0 flex items-center justify-center h-full w-full"
      >
        <aw-icon 
          icon="bug-report" 
          class="w-24 h-24 text-red-600"
        />
        <tippy 
          :content="$t('File has virus')" 
          theme='warning'
          to="parent"
        />
      </div>

      <div 
        v-else-if="hasPreview && !previewIsLoading" 
        class="swiper-wrapper"
      >
        <div class="swiper-slide">
          <img
            class="rounded-md pointer-events-none select-none"
            :src="item.previews['500x500']"
            alt=""
          />
        </div>
      </div>
      
      <div v-else>
        <div class="Square__Inicials rounded-md select-none">
          {{ item.ext.substring(0, 3) }}
        </div>
      </div>

      <span
        v-if="antivirusState && antivirusState !== 'hasVirus'"
        class="mr-2.5 sm:mr-3.5 absolute right-4 top-1 z-5"
      >
        <aw-icon 
          v-if="antivirusState === 'waiting'"
          v-tippy="$t('File is being checked for viruses')"
          icon="safety-check" 
          class="w-5 h-5 text-gray-400 "
        />
        <aw-icon 
          v-else-if="antivirusState === 'checked'"
          v-tippy="$t('File is safe')"
          icon="verified-user" 
          class="w-5 h-5 text-green-600 "
        />
      </span>

      <div
        ref="Square__Dot"
        :data-item-index="rank"
        class="Square__Dot cursor-pointer ring-white ring-1 z-7"
        :class="{
          'Square__Dot--active': bcSelectedStore.selected.has(item.id)
        }"
        @click.stop="bcSelectedStore.select(
          item, 
          {
            isRecursive: true,
            isShift: $event.shiftKey,
            itemIndex: rank,
          }
        )"
      />

      <!-- dots dropdown  -->
      <!--
      <aw-dropdown
        placement="bottom-end"
        :offset="[0, 8]"
        class="Square__Dots flex items-center justify-center cursor-pointer z-8"
      >
        <template v-slot:btn="{ toggle }">
          <div @click.stop="toggle" class="flex items-center justify-center">
            <aw-icon
              icon="dots"
              class="w-4 h-4  text-black hover:text-bc-blue"
            ></aw-icon>
          </div>
        </template>
        <template v-slot:dropdown="{ opened, dropdown }">
          <div
            v-show="opened"
            :ref="dropdown"
            class="Dropdown Dropdown--Hover absolute rounded-md bg-white  max-w-xs text-sm top-full right-0 shadow-md z-10"
          >
            <nav class="p-0">
              <a
                class="block py-1.5 px-3 text-gray-600 hover:text-gray-800"
                href=""
                >{{$t('Add to favourites')}}</a
              >
              <a
                class="block py-1.5 px-3 text-gray-600 hover:text-gray-800"
                href=""
                >{{$t('Edit button')}}</a
              >
              <a
                class="block py-1.5 px-3 text-gray-600 hover:text-gray-800"
                href=""
                >{{$t('Move / Copy')}}</a
              >
              <a
                class="block py-1.5 px-3 text-gray-600 hover:text-gray-800"
                href=""
                >{{$t('Move to trash')}}</a
              >
              <a
                class="block py-1.5 px-3 text-gray-600 hover:text-gray-800"
                href=""
                >{{$t('Show')}}</a
              >
            </nav>
          </div>
        </template>
      </aw-dropdown>
      -->
    </div>
    <div 
      class="Square__Text leading-tight py-1 text-sm"
      :class="antivirusState === 'hasVirus' ? 'text-red-600' : 'text-gray-500'"
    >
      <span class="opacity-0 line-clamp-2 pointer-events-none">
        {{ item.name }}
      </span>
      <a 
        class="Square__TextVisible" 
        :href="item.detail_url" 
        @click.stop.prevent="open"
      >
        {{ item.name }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import FileState from '../../mixins/FileState'
import Selected from '../../mixins/Selected'

export default {
  mixins: [
    FileState,
    Selected,
  ],
  props: ['item', 'rank'],
  computed: {
    file() {
      return this.item
    },
    ...mapStores(useBcSelectedStore),
  },
  methods: {
    open() {
      this.$router.push(this.item.detail_url.replace(/^(?:\/\/|[^/]+)*\//, ''))
    }
  },
  mounted() {
    this.assignItemToSelectBtn('Square__Dot', this.item)
  }
}
</script>

<style lang="scss" scoped></style>
